import React from "react";
import Product from "../../assets/images/Image 2.png";

const ProductDetails = () => {
  return (
    <section id="rfqProductDetails">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="card rfq-product-heading-card mb-1">
              <div className="card-header">
                <h5>
                  <span className="mr-3">
                    <i class="fas fa-chevron-left"></i>
                  </span>
                  1.5 hour Rated Static Fire Damper
                </h5>
              </div>
            </div>
            <div className="card rfq-product-img-card mb-1">
              <div className="card-body">
                <div className="row mt-2">
                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 my-auto">
                    <div className="d-flex">
                      <div className="text-center">
                        <img src={Product} />
                        <h6>GModel - 119</h6>
                      </div>
                      <div className="w-100">
                        <div className="content">
                          <div className="flex-column">
                            <h5>25 mm</h5>
                            <label>Slot Width</label>
                          </div>
                          <div className="flex-column">
                            <h5>Return</h5>
                            <label>Type</label>
                          </div>
                          <div className="flex-column">
                            <h5>Extruded Aluminum</h5>
                            <label>Material of Construction</label>
                          </div>
                          <div className="flex-column">
                            <h5>RAL 9010</h5>
                            <label>RAL Color</label>
                          </div>
                          <div className="flex-column">
                            <h5>Yes</h5>
                            <label>Opposed Blade Damper</label>
                          </div>
                          <div className="flex-column">
                            <h5>Yes</h5>
                            <label>Bank Off Plate</label>
                          </div>
                        </div>
                        <div className="content">
                          <div className="flex-column">
                            <h5>Aluminium-Painted Black</h5>
                            <label>Blank Off Plate Material</label>
                          </div>
                          <div className="flex-column">
                            <h5>456</h5>
                            <label>Bank Off Plate Length</label>
                          </div>
                          <div className="flex-column">
                            <h5>Without Insulation</h5>
                            <label>Plenum</label>
                          </div>
                          <div className="flex-column">
                            <h5>789854</h5>
                            <label>Plenum Width</label>
                          </div>
                          <div className="flex-column">
                            <h5>415</h5>
                            <label>Plenum Height</label>
                          </div>
                          <div className="flex-column">
                            <h5>9854</h5>
                            <label>Plenum Inlet Dia</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card mb-1 table-card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="table-responsive">
                      <table className="table table-borderless">
                        <thead>
                          <tr>
                            <th>Tag Ref</th>
                            <th>Other Ref</th>
                            <th>Size Parameters</th>
                            <th># of Slots</th>
                            <th>End Caps</th>
                            <th>Quantity</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>PRD12-87-85</td>
                            <td>OTREFZ78-J123</td>
                            <td>2400x3</td>
                            <td>25</td>
                            <td>One Side</td>
                            <td>2000</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductDetails;
